import { render } from "./Leaderboard.vue?vue&type=template&id=4d90f5a8"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"
script.render = render

export default script